export default "__VITE_ASSET__88497865__"